"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopSolid = exports.SideSolid = exports.TopGradient = exports.SideGradient = void 0;
const box_1 = require("../layout/box");
const styles_1 = require("../../styles");
exports.SideGradient = (0, styles_1.styled)(box_1.Box)(({ theme, animated }) => {
    return {
        position: 'absolute',
        width: '8px',
        left: '0',
        top: '0',
        bottom: '0',
        background: `linear-gradient( ${theme.colors.azure} 0%, #00BFFF 57.47%, #23E5E5 100%)`,
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        backgroundSize: animated ? '100% 200%' : null,
        animation: animated ? `${styles_1.Theme.keyframes.backgroundVerticalPulse} 2s ease infinite` : null,
    };
});
exports.TopGradient = (0, styles_1.styled)(box_1.Box)(({ theme, animated, customAnimatedColor }) => ({
    position: 'absolute',
    height: '8px',
    left: '0',
    top: '0',
    right: '0',
    background: animated
        ? `linear-gradient(
        to right,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 0%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : theme.colors.azure} 10%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : '#00BFFF'} 35%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : '#23E5E5'} 40%,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 45%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : theme.colors.azure} 60%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : '#00BFFF'} 75%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : '#23E5E5'} 80%,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 85%,
        ${customAnimatedColor !== null && customAnimatedColor !== void 0 ? customAnimatedColor : theme.colors.azure} 100%
    )`
        : `linear-gradient(to right, ${theme.colors.azure} 0%, #00BFFF 57.47%, #23E5E5 100%)`,
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    backgroundSize: animated ? '600% 100%' : null,
    animation: animated
        ? `${styles_1.Theme.keyframes.backgroundHorizontalPulseLTR} 2s linear infinite`
        : null,
    animationFillMode: 'backwards',
}));
exports.SideSolid = styles_1.styled.div(({ theme, decoratorColor }) => {
    return {
        position: 'absolute',
        width: '8px',
        left: '0',
        top: '0',
        bottom: '0',
        background: theme.colors[decoratorColor],
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
    };
});
exports.TopSolid = styles_1.styled.div(({ theme, decoratorColor }) => {
    return {
        position: 'absolute',
        height: '8px',
        left: '0',
        top: '0',
        right: '0',
        background: theme.colors[decoratorColor],
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
    };
});
//# sourceMappingURL=decorators.js.map